import React from 'react';
import t from 'tcomb';
import HTMLComponent from './HTMLComponent';
import Locale from '../domain/Locale';
import Amount from '../domain/Amount';
import get_bundle from '../domain/get_bundle';
import CouponShipping from './CouponShipping';
import micromd from '../../micromd';
import { props } from 'tcomb-react';

@props({
  locale: Locale,
  product: t.Obj
})
export default class ProductShippings extends React.Component {

  getCouponShipping() {
    return (<CouponShipping
      locale={this.props.locale}
      currency={this.props.product.currency} />);
  };

  getHtmlShippingsGroupped() {
    let shippings_groupped = {};
    let html = "";
    const locale = this.props.locale;
    this.props.product.shippings.map( (shipping) => {
      const k = shipping.cost + "_" + shipping.description;

      if (shippings_groupped[k]) {
        shippings_groupped[k].shippings.push({
          id: shipping.id,
          country: shipping.country,
        });
      } else {
        shippings_groupped[k] = {
          cost: shipping.cost,
          description: shipping.description,
          shippings: [{
            id: shipping.id,
            country: shipping.country,
          }]
        };
      }
    });

    const getShippingDisplayCountry = (shipping) => {
      return this.props.locale.display_country(shipping.country);
    };
    for (let shipping_groupped in shippings_groupped) {
      const obj = shippings_groupped[shipping_groupped];
      let country = '';
      const cost = Amount.format(locale, this.props.product.currency, obj.cost) + '<br/>';
      const description = micromd(obj.description);
      country = get_bundle(locale).order.shippings.country +
        ': ' +
        obj.shippings.map(getShippingDisplayCountry).join(", ") +
        '<br/>';
      html += country + description + '<br/><hr>';
    }
    return (<HTMLComponent>{html}</HTMLComponent>);
  }

  render() {
    if (this.props.product.is_coupon) {
      return this.getCouponShipping();
    }
    return this.getHtmlShippingsGroupped(this.props.locale);
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/ProductShippings.js
 **/